import { getFuelDisplayLabel } from '@rta/rta-blueprint-library';

/**
 * Blueprint-view alias for the library's canonical fuel-source label. Kept as a
 * named helper so the blueprint pages import a view-local name; the mapping logic
 * (and the "never default to Natural Gas" guarantee) lives in one place.
 */
export const getFuelSourceLabel = (fuelChoice: string | null | undefined): string => getFuelDisplayLabel(fuelChoice);
